import { createFileRoute } from "@tanstack/react-router";
import MaintenanceChecklist from "@/pages/MaintenanceChecklist";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/maintenance-checklist")({
  head: () =>
    seo({
      title: "Minnesota Home Maintenance Checklist | Roof, Siding & Gutters",
      description:
        "A free season-by-season maintenance checklist for Minnesota homes — ice dam prevention, gutter and roof checks, siding, decks, and what to do after a hail storm. From Cedar Creek Construction.",
      path: "/maintenance-checklist",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Home Maintenance Checklist", path: "/maintenance-checklist" },
      ]),
    }),
  component: MaintenanceChecklist,
});
